import { RevisionDestinationBase } from './revision-destination-base';
export class DeletedRunContentDestination extends RevisionDestinationBase {
}
